'use es6';

import { Component } from 'react';
import styled from 'styled-components';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReassignmentSelectInput = styled.div.withConfig({
  displayName: "ReassignmentSelectInputPlaceholder__ReassignmentSelectInput",
  componentId: "sc-810xij-0"
})(["padding:10px;padding-left:0;width:150px;height:42px;display:flex;align-items:center;"]);
const Details = styled.div.withConfig({
  displayName: "ReassignmentSelectInputPlaceholder__Details",
  componentId: "sc-810xij-1"
})(["display:flex;flex-direction:column;justify-content:space-around;width:100%;height:100%;"]);
export default class ReassignmentSelectInputPlaceholder extends Component {
  render() {
    return /*#__PURE__*/_jsxs(ReassignmentSelectInput, {
      disabled: true,
      "data-test-id": "reassignment-select-placeholder",
      children: [/*#__PURE__*/_jsx(SkeletonCircle, {
        size: 24,
        className: "m-right-1"
      }), /*#__PURE__*/_jsxs(Details, {
        children: [/*#__PURE__*/_jsx(SkeletonBox, {
          width: "50%",
          height: "0.75em"
        }), /*#__PURE__*/_jsx(SkeletonBox, {
          width: "100%",
          height: "0.75em"
        })]
      })]
    });
  }
}
ReassignmentSelectInputPlaceholder.displayName = 'ReassignmentSelectInputPlaceholder';